// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"26a9b0a4","239":"c7a5e0e8","455":"4e3d436d"}[chunkId] + ".chunk.js";
};